module.exports = __webpack_public_path__ + "img/de.13a12944.png";